/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */
import React, { forwardRef } from 'react';

import 'moment/locale/pt-br';

import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

import { useAuth } from '../../../hooks/auth';

import stylesMaterial from './stylesMaterial';
import { Container, Complemento, TotalItem, Produto } from './styles';
import { IOrder } from '../../../interfaces/IOrder';
import { IDeliveryAddress } from '../../../interfaces/IDeliveryAddress';
import { IPaymentMethod } from '../../../interfaces/IPaymentMethod';
import { IOrderItem } from '../../../interfaces/IOrderItem';
import estagiosPedido from '../../../utils/estagiosPedido';

interface ComponentToPrintProps {
  pedido: Partial<IOrder> & {
    deliveryAddress?: Partial<IDeliveryAddress> | undefined;
    orderPayment: Partial<IPaymentMethod> & {
      companyPaymentMethod?: any;
    };
    items: Partial<IOrderItem>[];
  };
  selectedHour: string;
}

const ComponentToPrintEdited = forwardRef<HTMLDivElement, ComponentToPrintProps>(
  (props, ref) => {
    const classes = stylesMaterial();
    const { pedido, selectedHour } = props;

    const { user } = useAuth();
    const moment = require('moment');

    return (
      <Container ref={ref}>
        <Typography className={classes.empresa}>
          {user.empresa_nome_fantasia}
        </Typography>

        <Typography className={classes.texto}>
          {`Funcionário: ${user.nome}`}
        </Typography>

        <Typography className={classes.texto}>
          Emissão: {moment(new Date(selectedHour)).format('LT | L')}
        </Typography>

        <Typography className={classes.texto}>
          {`Pedido: ${props.pedido.id}`}
        </Typography>

        {pedido.scheduledDeliveryAt && (
          <>
            <Divider className={classes.divider} />
            <Typography className={classes.texto}>
              {`Entrega programada para: ${moment(
                new Date(pedido.scheduledDeliveryAt),
              ).format('LT | L')}`}
            </Typography>
            <Divider className={classes.divider} />
          </>
        )}

        <Typography className={classes.clienteInfo}>
          Cliente: <strong>{pedido?.customer?.tradingName ?? 'Venda balcão'}</strong>
        </Typography>

        {pedido.deliveryAddress ? (
          <Typography className={classes.clienteInfo}>
            Endereço:
            <strong>
              <br />
              {`${pedido.deliveryAddress.address.logradouro}, ${pedido.deliveryAddress.address.numero}, ${pedido.deliveryAddress.address.bairro}`}
              <br />
              {`${pedido.deliveryAddress.address.cidade}, ${pedido.deliveryAddress.address.estado}, ${pedido.deliveryAddress.address.cep}`}
              <br />
              Complemento:
              <br />
              {`${pedido.deliveryAddress.address.complemento}`}
            </strong>
          </Typography>
        ) : (
          <Typography className={classes.clienteInfo}>
            Entrega: <strong>Retirada balcão</strong>
          </Typography>
        )}

        {pedido?.customer && (
          <Typography className={classes.clienteInfo}>
            Telefone: <strong>{pedido.customer.phoneNumber}</strong>
          </Typography>
        )}

        <Typography className={classes.tituloProdutos}>Produção</Typography>

        <Divider className={classes.divider} />

        <Typography className={classes.texto}>
          Descrição
        </Typography>

        <Divider className={classes.divider} />

        {pedido.items.filter(item => item.createdAt.localeCompare(selectedHour) === 0).map((item) => {
          return (
            <>
              <Produto>
                <Typography className={classes.productText}>
                  {`${item.portioned
                    ? `${
                        item.quantity >= 1
                          ? Number(item.quantity).toFixed(3)
                          : item.quantity * item.measurementUnit[0].quantityPortion
                      }${
                        item.quantity >= 1 
                          ? item.measurementUnit[0].acronym
                          : item.measurementUnit[0].acronymPortion
                      }`
                    : Number(item.quantity)}. `}
                  {!item.colorName && item.sizeName ? (
                    `Pizza ${String(item.sizeName).toLowerCase()}`
                  ) : item.colorName ? (
                    <div>
                      <p>{item.productName}</p>
                      <p>
                        {item.productGridName}
                        {item.colorName && ` - ${item.colorName}`}
                      </p>
                    </div>
                  ) : (item.portioned && pedido.status === estagiosPedido.separacao ? 
                    item.productName + ' - Separar' :
                    item.productName
                  )}
                </Typography>
              </Produto>

              {item.childOrderItems?.map((complemento) => {
                return (
                  <Complemento>
                    <Typography className={classes.nomeComplemento}>
                      <>
                        {Number(complemento.quantity)} {complemento.productName}
                      </>
                    </Typography>
                  </Complemento>
                );
              })}
              {!!item.observation && (
                <Typography className={classes.observation}>
                  Obs: {item.observation}
                </Typography>
              )}
            </>
          );
        })}

        {!!pedido.observation && (
          <>
            <Divider className={classes.divider} />

            <Typography className={classes.observation}>
              Observação: <br />
              {pedido.observation}
            </Typography>
          </>
        )}

        
      </Container>
    );
  },
);

export default ComponentToPrintEdited;
